<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)" style="cursor: pointer;">close</mat-icon>
  </div>
  <div class="content">
    <form>
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Ship Length :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.ship_length" name="ship_length" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Ship Breadth :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.ship_breadth" name="ship_breadth" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Windage Area :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.windage_area" name="windage_area" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Power :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.power" name="power" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Wind Drag Coefficient :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.wind_drag_coef" name="wind_drag_coef" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Air Density :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.air_density" name="air_density" autocomplete="off">
      </div>
  
      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Empirical Constant :</label>
        <input type="text" class="form-control col-md-9" [(ngModel)]="formData.empirical_constant" name="empirical_constant" autocomplete="off">
      </div>
  
      <button type="button" class="btn btn-light hover-clear clear" (click)="onSubmit(true)" >
        <span>Submit</span>
    </button>
    </form>
  </div>
  
</div>
